import React from 'react';
import { useLang } from "../../../contexts/LanguageContext";
import dictionary from '../../../images/dictionary.svg';

const availableDicts = {
  'esp': 'Español',
  'eng': 'English',
  'fra': 'Français'
};

function createSelectWithArray(options, name, onChange, value) {
  const size = Math.min(Math.max(Object.keys(options).length, 2), 5);
  return (
    <select name={name} className="settings-form-select" size={size} id={name} onChange={onChange} value={value}>
      {Object.entries(options).map(([value, label]) => (
        <option className="settings-menu-item" value={value} key={value}>
          {label}
        </option>
      ))}
    </select>
  );
}

export const DictionarySettings = ({ preferences, onDictLanguageChange, onChange }) => {
  const { t } = useLang();

  const handleDictLanguageChange = (e) => {
    onChange('dictLanguage', e.target.value);
    onDictLanguageChange(e.target.value);
  };

  return (
    <div className="pb-5">
      <label htmlFor="dictLanguage" className="settings-label"><img src={dictionary} className="settingsLabelIcon" alt={t("CHAPTER_DICTIONARY_LAGUAGE_ICON")} />{t("CHAPTER_DICTIONARY_LAGUAGE")}</label>
      {createSelectWithArray(availableDicts, "dictLanguage", handleDictLanguageChange, preferences.dictLanguage)}
    </div>
  );
};
